let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ajjlj")).then(() => parcelRequire('g8im1'));